export default function ReviewCard(props) {
    return <>
        <div className="card mx-auto shadow-lg" style={{"width" : "90%"}}>
            <div className="card-body">
                <blockquote className="blockquote mb-0">
                    <p>"{props.review}"</p>
                    <br />
                    <footer className="blockquote-footer">{props.reviewer}</footer>
                </blockquote>
            </div>
        </div>
    </>
}
